import React from "react";
import { ModalBody, ModalHeader, ModalFooter, Button, Modal } from "reactstrap";

const DeleteReservationModal = ({
  isOpen,
  reservation,
  isDeleting,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>
        <span className="reservations-modal__title">Delete Reservation</span>
      </ModalHeader>
      <ModalBody>
        <p className="reservations-modal__helper" style={{ marginBottom: 0 }}>
          You are about to delete reservation{" "}
          <strong>{reservation && reservation.reservation_number}</strong>. This action
          cannot be undone from the interface.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
          Delete Reservation
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteReservationModal;
